<template lang="pug">
  //- drug list 
  div.drug-panel
    div.drug-panel--head
      button.btn.btn-info.icon-right(@click="createForm = true") 新增藥物
      CreateMedicineForm(v-if="createForm" v-on:closeForm="closeForm")
      form.form-inline(@submit.prevent="onFilterSet")
        input.form-control.mr-2(type="text" v-model="medName" placeholder="輸入藥碼, 學名或料位號")
        button.btn.btn-primary(type="submit") 搜尋
    vuetable(
      ref="vuetableMed"
      :api-url="`${server}/api/medication/?type=normal`"
      data-path="results"
      :fields="fields"
      :http-options="httpOptions"
      pagination-path=""
      :css="boostrapCss"
      :perPage=30
      @vuetable:pagination-data="onPaginationData"
      detail-row-component="drug-settings-detail"
      :append-params="moreParams" 
      @vuetable:cell-clicked="onMedClicked"
    )

    vuetable-pagination(
      ref="pagination"
      :css="boostrapCss.pagination"
      @vuetable-pagination:change-page="onChangePage"
    )
</template>

<script>
import Vue from 'vue';
import Vuetable from 'vuetable-2/src/components/Vuetable';
import VuetablePagination from 'vuetable-2/src/components/VuetablePagination';
import readCookie from '@/vuex/functions/readCookie';
import server from '@/config';

import CreateMedicineForm from '../../common/CreateMedicineForm';
import DrugSettingsDetail from './DrugSettingsDetail';

Vue.component('drug-settings-detail', DrugSettingsDetail);

export default {
  name: 'DrugDBSettings',
  data() {
    return {
      boostrapCss: {
        tableClass: 'table table-striped table-bordered table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: '',
          },
        },
      },
      httpOptions: {
        headers: {
          Authorization: `Token ${readCookie('Token')}`,
        },
      },
      fields: [
        {
          name: 'code',
          sortField: 'code',
          title: '藥碼',
        },
        {
          name: 'CGMH_number',
          sortField: 'CGMH_number',
          title: '料位號',
        },
        {
          name: 'generic_name',
          sortField: 'generic_name',
          title: '學名',
        },
        // {
        //   name: 'product_name',
        //   title: '產品名',
        // },
        {
          name: 'pack_content',
          title: 'pc/盒',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'restrained_class',
          title: '管制等級',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
      ],
      server,
      createForm: false,
      moreParams: {},
      medName: '',
    };
  },
  components: {
    Vuetable,
    VuetablePagination,
    CreateMedicineForm,
  },
  computed: {
    instance() {
      return this.$store.state.instance;
    },
  },
  methods: {
    getSortParam(sortOrder) {
      return sortOrder.map((sort) => {
        return (sort.direction === 'desc' ? '-' : '') + sort.field;
      }).join(',');
    },
    onPaginationData(paginationData) {
      // this.$refs.paginationInfoTop.setPaginationData(paginationData);
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetableMed.changePage(page);
    },
    onMedClicked(data, field, event) {
      this.$refs.vuetableMed.toggleDetailRow(data.id);
    },
    onFilterSet() {
      this.moreParams = {
        search: this.medName,
      };
      const vm = this;
      Vue.nextTick(() => this.$refs.vuetableMed.refresh());
    },
    closeForm() {
      this.createForm = false;
    },
  },
};
</script>




// WEBPACK FOOTER //
// DrugDBSettings.vue?2d7523b7